/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { Layout } from "antd";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { Typography, Card, Space, Button, Spin, Table, Tag } from "antd";
import { DASH_DATA } from "../../constants/api";
import { useNavigate } from "react-router-dom";
import { primaryLightenColor, getAPI } from "../../utils/common";
import { displayMessage } from "../../utils/common";
import { ERROR_MSG_TYPE } from "../../constants/messages";
import "./dashboard.css";
import LS_SERVICE from "../../utils/localStorage";
import { CURRENCY } from "../../constants/constent";
import dayjs from "dayjs";
import { ReloadOutlined } from "@ant-design/icons";

function Dashboard() {
  const { Content } = Layout;
  const { Title } = Typography;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [dashData, setDashData] = useState([]);
  const [state, setState] = useState([]);
  // For Greeting
  let greeting;
  const date = new Date();
  const currentTime = date.getHours();
  if (currentTime >= 0 && currentTime <= 12) {
    greeting = "Good Morning";
  } else if (currentTime > 12 && currentTime <= 18) {
    greeting = "Good Afternoon";
  } else {
    greeting = "Good Evening";
  }

  useLayoutEffect(() => {
    getDashData();
  }, []);

  const handleRefresh = async () => {
    setRefreshing(true);
    try {
      await getDashData(); // Replace with your data fetching function
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setRefreshing(false);
    }
  };
  const getDashData = () => {
    setLoading(true);
    const successFn = function (data) {
      setLoading(false);
      if (data.status === true) {
        const rData = data.data.todayOrders.map((row, index) => ({
          key: index,
          id: index + 1,
          gen_order_id: row.gen_order_id,
          name: row.user.name,
          mobile: row.user.mobile,
          total_bill: `${CURRENCY} ${row.total_bill}`,
          total_items: row.total_items,
          total_items_tag: <Tag color={`success`}>{row.total_items}</Tag>,
          status: row.status,
          payment_by: row.payment_by,
          payment_status: row.payment_status,
          order_date: dayjs(row.order_date).format("DD-MM-YYYY"),
          total_bill_tag: (
            <span>
              <Tag
                color={row.payment_status === "Success" ? `success` : `error`}
              >{`${CURRENCY} ${row.total_bill}`}</Tag>
            </span>
          ),
          status_tag: (
            <span>
              <Tag color={row.status === "Delivered" ? `success` : `error`}>
                {row.status}
              </Tag>
            </span>
          ),
          action: (
            <Space>
              <Button
                loading={loading}
                disabled={loading}
                onClick={() => {
                  navigate("/order/view/" + row.gen_order_id);
                }}
                block
              >
                View
              </Button>
            </Space>
          ),
        }));
        setState(rData);
        setDashData(data.data.grid_items);
        setLoading(false);
      } else {
        setState([]);
        setDashData([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setDashData([]);
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to get Dashboard Data");
    };
    getAPI(DASH_DATA, successFn, errorFn);
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "id",
      width: 50,
    },
    {
      title: "Order ID",
      dataIndex: "gen_order_id",
      width: 50,
    },
    {
      title: "Name",
      dataIndex: "name",
      width: 50,
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      width: 50,
    },
    {
      title: "Items",
      dataIndex: "total_items_tag",
      width: 50,
    },
    {
      title: "Order Date",
      dataIndex: "order_date",
      width: 150,
    },
    {
      title: "Bill",
      dataIndex: "total_bill_tag",
      width: 50,
    },
    {
      title: "Payment By",
      dataIndex: "payment_by",
      width: 50,
    },
    {
      title: "Status",
      dataIndex: "status_tag",
      width: 50,
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 100,
    },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Spin spinning={loading}>
          <Card
            key={1}
            title={
              <span>
                <Title key={2} level={5}>
                  {greeting}, {LS_SERVICE.get("name")} (
                  {LS_SERVICE.get("user_type").toUpperCase()})
                </Title>
              </span>
            }
            extra={
              <Button
                type="primary"
                icon={<ReloadOutlined />}
                onClick={handleRefresh}
                loading={refreshing}
                style={{ marginBottom: "10px" }}
              >
                Refresh
              </Button>
            }
          >
            <div class="row">
              {dashData.map((item, index) => (
                <div class="column">
                  <div
                    style={{ background: primaryLightenColor() }}
                    class="cards"
                  >
                    <p className="count">{item.value}</p>
                    <span class="title">{item.label}</span>
                    <div
                      style={{ background: primaryLightenColor() }}
                      className="icon-card"
                    >
                      {/* <div style={{ fontSize: "20px", color: "white" }}>
                        <AppstoreOutlined />
                      </div> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </Spin>
        <Table
          loading={loading ? true : false}
          columns={columns}
          dataSource={state}
          pagination={{ pageSize: 10 }}
          scroll={{ x: 240 }}
          style={{ marginTop: "10px" }}
        />
      </Content>
      <LayoutFooter />
    </Layout>
  );
}
export default Dashboard;
